import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './bulk-delete-assets-confirm-dialog.controller';
import template from './bulk-delete-assets-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId,
    assets,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        customerId,
        assets,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.bulkDeleteAssetsConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkDeleteAssetsConfirmDialog', dialogService)
  .name;
